import VOverlay from './VOverlay'

export { VOverlay }

export default VOverlay



// WEBPACK FOOTER //
// ../../../src/components/VOverlay/index.ts